import { useState, useCallback } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
import { OnboardingChecklist } from '../modules/OnboardingChecklist';
import { useGoShortcuts, useShortcutHelp } from '../../hooks/useKeyboardShortcuts';

export function AppLayout() {
  useGoShortcuts();
  useShortcutHelp();

  const [mobileOpen, setMobileOpen] = useState(false);
  const closeMobile = useCallback(() => setMobileOpen(false), []);
  const toggleMobile = useCallback(() => setMobileOpen((prev) => !prev), []);

  return (
    <div className="flex h-screen overflow-hidden bg-surface-950">
      <Sidebar mobileOpen={mobileOpen} onMobileClose={closeMobile} />
      <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
        <TopBar onMenuToggle={toggleMobile} />
        <main className="flex-1 overflow-y-auto bg-surface-900/50 p-3 md:p-6">
          <div className="page-enter">
            <Outlet />
          </div>
        </main>
      </div>
      <OnboardingChecklist />
    </div>
  );
}
